// Translations for S&K FACADE PANELS — Official MG Bond Distributor
export const translations = {
  mk: {
    brand: { name: "С&К ФАСАДНИ ПАНЕЛИ", short: "С&К", tagline: "Фасадни Панели" },
    distributor: "Официјален дистрибутер на MG Bond",
    nav: {
      product: "Производ",
      finishes: "Каталог",
      specs: "Спецификации",
      sustainability: "Одржливост",
      contact: "Контакт",
      requestQuote: "Побарај понуда",
      viewCatalogue: "Преземи каталог",
    },
    hero: {
      eyebrow: "АЛУМИНИУМСКИ КОМПОЗИТНИ ПАНЕЛИ",
      subEyebrow: "Официјален дистрибутер на MG Bond",
      headlineBold: "Премиум",
      headlineRest: "фасадни решенија",
      description:
        "Премиум алуминиумски композитни панели од MG BOND за градежни објекти — лесни, цврсти, отпорни на временски услови. Голем избор на бои и димензии, испорачани во рок.",
      cta: "Преземи каталог",
      marquee: ["MG Bond ACP", "PE · HDPE · PVDF", "1250 мм / 3200 мм", "2–6 мм дебелина", "100% рециклиран", "Огноотпорни јадра"],
    },
    product: {
      label: "02 — За производот",
      sideTitle: ["MG Bond", "Премиум", "ACP"],
      headlineL1: "Премиум алуминиумски",
      headlineL2: "композитни панели",
      headlineL3: "од MG Bond.",
      body1:
        "Премиум алуминиумски композитни панели од MG Bond — светски препознатлив бренд познат по врвен квалитет, модерен дизајн и одржливо производство.",
      body2:
        "Создадени за современи архитектонски и градежни проекти, MG Bond панелите комбинираат издржливост, естетика и високи перформанси во секој детал. Произведени со 100% рециклиран алуминиум и напредна технологија, тие претставуваат паметно и одржливо решение за модерното градење.",
      body3:
        "Без разлика дали станува збор за фасади, ентериерни решенија или креативни архитектонски концепти, обезбедуваме сигурни производи кои ги исполнуваат највисоките стандарди за квалитет и стил.",
      body4:
        "MG Bond алуминиумските композитни панели користат 100% полиетиленски материјал. Полиетиленот обезбедува отпорност на абразија и можност за лесно свиткување без кршење. Во комбинација со легурата 3004, ги подобрува механичките својства и обезбедува супериорни перформанси. Достапни се различни бои на јадрото за полиетиленскиот материјал.",
      stats: [
        { k: "5.5", v: "кг / м²", l: "Просечна тежина, панел од 4 мм" },
        { k: "B1 / A2", v: "EN 13501-1", l: "Огноотпорност (B1, A2 класа)" },
        { k: "20", v: "Години", l: "Гаранција на фасада, PVDF премаз" },
        { k: "RAL", v: "Голем избор", l: "Голем избор на бои" },
      ],
      sustainability: [
        { k: "100%", v: "Рециклиран алуминиум", l: "Целосно повратливо во новиот производствен циклус." },
        { k: "0", v: "Тешки метали", l: "Без олово, кадмиум или хром во премазот." },
        { k: "EU", v: "Еко-производство", l: "Производство усогласено со европските еколошки стандарди." },
      ],
    },
    advantages: {
      label: "03 — Зошто ACP",
      title: "Зошто алуминиумски композитни панели.",
      intro:
        "Шест мерливи придобивки кои ги прават MG Bond ACP панелите совршен материјал за современи фасади.",
      items: [
        { k: "01", t: "Лесна конструкција", d: "Околу 5.5 кг/м² за 4 мм панел — без губиток во крутоста и отпорноста на материјалот, побрза монтажа и пониски трошоци." },
        { k: "02", t: "Издржливост на временски услови", d: "Coil-coated PVDF премазот е отпорен на UV, влага и термички промени над 20 години со минимално одржување." },
        { k: "03", t: "Термичка изолација", d: "Композитното јадро го намалува преносот на топлина низ фасадата и поддржува енергетски ефикасни објекти." },
        { k: "04", t: "Звучна изолација", d: "Сендвич структурата ги намалува надворешните звуци — мерлива придобивка за урбани проекти." },
        { k: "05", t: "Огноотпорност", d: "A2 / B1 јадра ги исполнуваат EN 13501-1 и строгите стандарди за комерцијални објекти." },
        { k: "06", t: "Естетска флексибилност", d: "Brushed, Mirror, Wooden, Metallic и било кој RAL — слобода во боја и текстура за секој архитектонски јазик." },
      ],
    },
    finishes: {
      label: "04 — Каталог на бои",
      headlineL1: "MG Bond палета.",
      headlineL2: "",
      intro:
        "Целосна MG Bond палета — еднобојни, металик, огледални, четкани и дрвени декори. Прилагодени бои достапни за тендерски проекти.",
      items: {
        "01": { name: "Мат црна", ral: "RAL 9005", desc: "Длабока, нерефлектирачка црна. Архитектонски акцент." },
        "02": { name: "Четкан сребрен", ral: "Метален 9006", desc: "Линеарно-зрнест анодизиран изглед." },
        "03": { name: "Дрвен декор", ral: "Природен даб", desc: "Фотореалистичен дрвен принт." },
        "04": { name: "Чиста бела", ral: "RAL 9016", desc: "Чиста бела ПВДФ. Универзална палета." },
        "05": { name: "Антрацит", ral: "RAL 7016", desc: "Длабока архитектонска сива." },
        "06": { name: "Шампањ злато", ral: "Метално злато", desc: "Суптилна метална топлина." },
        "07": { name: "Огледален сјај", ral: "Високосјаен сребрен", desc: "Огледален премаз. Спекуларна рефлексија." },
      },
    },
    specs: {
      label: "05 — Спецификации",
      title: "Општи информации",
      intro: "",
      headers: ["Достапна димензија", "Стандард", "Опции"],
      rows: [
        ["Ширина", "1.250 мм", "1.000 — 1.220 мм · 1.500 — 2.000 мм"],
        ["Должина", "3.200 мм", "2.000 — 6.000 мм"],
        ["Вкупна дебелина", "2 / 3 / 4 / 5 / 6 мм", "По нарачка"],
        ["Дебелина на алуминиум", "0.21 / 0.30 / 0.40 / 0.50 мм", "—"],
        ["Површина и боја", "PVDF премаз", "Brushed · Mirror · Wooden · Metallic · Gloss · PE · HDPE"],
        ["Пакување", "Дрвена палета", "—"],
      ],
    },
    layers: {
      label: "06 — Структура",
      title: "Слоеви на ACP",
      intro: "Повеќеслојна композитна структура за оптимална крутост, тежина и долговечност.",
      items: [
        { n: "01", name: "Заштитен слој", desc: "Отстранлив слој што ја штити површината при транспорт и монтажа." },
        { n: "02", name: "Полиестерска / PVDF боја", desc: "Coil-coated премаз отпорен на UV, корозија и временски услови." },
        { n: "03", name: "Алуминиумска плоча", desc: "Coil-coated алуминиумски слој од 0.21–0.50 мм за крутост и форма." },
        { n: "04", name: "Лепило", desc: "Високотемпературно ламинатно лепило што ги поврзува слоевите." },
        { n: "05", name: "Полиетиленско / FR јадро", desc: "PE или огноотпорно минерално јадро (B1 / A2) за стабилност." },
      ],
    },
    sustainability: {
      label: "07 — Одржливост",
      title: "Изградено за следната генерација.",
      intro: "MG Bond е изработен според највисоките еколошки стандарди.",
      items: [
        { k: "100%", v: "Рециклирачки алуминиум", l: "Целосно повратливо во новиот производствен циклус." },
        { k: "0", v: "Тешки метали", l: "Без олово, кадмиум или хром во премазот." },
        { k: "EU", v: "Еко-производство", l: "Производство усогласено со европските еколошки стандарди." },
      ],
    },
    contact: {
      label: "07 — Барање за понуда",
      headlineL1: "Барање",
      headlineL2: "за понуда.",
      intro: "",
      callLabel: "Јави се",
      emailLabel: "Е-пошта",
      whatsappLabel: "WhatsApp",
      officeLabel: "Канцеларија",
      officeValue: "Скопје, Македонија",
      form: {
        nameLabel: "Име / Фирма",
        namePh: "Целосно име или назив на фирма",
        emailLabel: "Е-пошта",
        emailPh: "вие@компанија.com",
        phoneLabel: "Телефон (опционално)",
        phonePh: "+389 …",
        messageLabel: "Опис на проектот",
        messagePh: "Обем (м²), финиш, рок, локација…",
        eta: "",
        submit: "Испрати барање",
        sending: "Испраќање",
        successToast: "Барањето е примено. Ќе одговориме во рок од еден работен ден.",
        genericError: "Не можеме да ја испратиме вашата порака. Обидете се повторно.",
        errors: { name: "Внесете го вашето име.", email: "Внесете валидна е-пошта.", message: "Пораката мора да има најмалку 5 знаци.", submit: "Поднесувањето не успеа." },
      },
    },
    footer: {
      description: "Официјален дистрибутер на MG Bond алуминиумски композитни панели.",
      contact: "Контакт", office: "Канцеларија", city: "Скопје", country: "Македонија",
      copyright: "© {year} С&К Фасадни Панели", rights: "Сите права задржани",
    },
    lang: { switchTo: "EN", current: "MK" },
    docTitle: "С&К Фасадни Панели — Официјален MG Bond дистрибутер",
  },

  en: {
    brand: { name: "S&K FACADE PANELS", short: "S&K", tagline: "Facade Panels" },
    distributor: "Official MG Bond Distributor",
    nav: {
      product: "Product",
      finishes: "Catalogue",
      specs: "Specs",
      sustainability: "Sustainability",
      contact: "Contact",
      requestQuote: "Request quote",
      viewCatalogue: "View catalogue",
    },
    hero: {
      eyebrow: "ALUMINIUM COMPOSITE PANELS",
      subEyebrow: "Official MG Bond Distributor",
      headlineBold: "Premium",
      headlineRest: "facade solutions",
      description:
        "Premium aluminium composite panels by MG BOND for construction projects — lightweight, rigid, weather-resistant. A wide range of colours and dimensions, delivered on schedule.",
      cta: "View catalogue",
      marquee: ["MG Bond ACP", "PE · HDPE · PVDF", "1250 mm / 3200 mm", "2–6 mm thickness", "100% recycled", "Fire-retardant cores"],
    },
    product: {
      label: "02 — About",
      sideTitle: ["MG Bond", "Premium", "ACP"],
      headlineL1: "Premium aluminium",
      headlineL2: "composite panels",
      headlineL3: "by MG Bond.",
      body1:
        "Premium aluminium composite panels by MG Bond — a globally recognised brand known for top-tier quality, modern design and sustainable manufacturing.",
      body2:
        "Engineered for contemporary architecture and construction, MG Bond panels combine durability, aesthetics and high performance in every detail. Produced with 100% recycled aluminium and advanced technology, they are a smart and sustainable solution for modern building.",
      body3:
        "Whether for facades, interior applications or creative architectural concepts, we deliver reliable products that meet the highest standards of quality and style.",
      body4:
        "MG Bond aluminium composite panels use 100% polyethylene material. Polyethylene offers abrasion resistance and the ability to be easily bent without breaking. Combined with the 3004 alloy, it enhances mechanical properties and provides superior performance characteristics. Different core colours are available for the polyethylene material.",
      stats: [
        { k: "5.5", v: "kg / m²", l: "Avg. weight, 4mm panel" },
        { k: "B1 / A2", v: "EN 13501-1", l: "Fire resistance (B1, A2 class)" },
        { k: "20", v: "Years", l: "Façade warranty, PVDF coating" },
        { k: "RAL", v: "Wide range", l: "A wide range of colours" },
      ],
      sustainability: [
        { k: "100%", v: "Recycled aluminium", l: "Fully recoverable into new production cycles." },
        { k: "0", v: "Heavy metals", l: "No lead, cadmium or chromium in the coating." },
        { k: "EU", v: "Eco production", l: "Manufacturing aligned with European environmental standards." },
      ],
    },
    advantages: {
      label: "03 — Why ACP",
      title: "Why aluminium composite panels.",
      intro:
        "Six measurable advantages that make MG Bond ACP the perfect material for contemporary facades.",
      items: [
        { k: "01", t: "Lightweight construction", d: "Around 5.5 kg/m² for a 4mm panel — without compromising rigidity or material resistance, with faster installation and lower costs." },
        { k: "02", t: "All-weather durability", d: "Coil-coated PVDF resists UV, moisture and thermal cycling for 20+ years with minimal maintenance." },
        { k: "03", t: "Thermal performance", d: "The composite core reduces heat transfer through the facade envelope, supporting energy-efficient building targets." },
        { k: "04", t: "Acoustic damping", d: "The sandwich structure attenuates exterior noise — a measurable benefit for urban projects." },
        { k: "05", t: "Fire safety", d: "A2 / B1 fire-retardant cores meet EN 13501-1 and stringent commercial fire codes." },
        { k: "06", t: "Aesthetic flexibility", d: "Brushed, Mirror, Wooden, Metallic and any RAL — colour and texture freedom for any architectural language." },
      ],
    },
    finishes: {
      label: "04 — Colour catalogue",
      headlineL1: "MG Bond palette.",
      headlineL2: "",
      intro:
        "The complete MG Bond palette — solids, metallic, mirror, brushed and wood prints. Custom colours available for tendered projects.",
      items: {
        "01": { name: "Matte Black", ral: "RAL 9005", desc: "Deep, non-reflective black. Architectural anchor." },
        "02": { name: "Brushed Silver", ral: "Metallic 9006", desc: "Linear-grain anodized look." },
        "03": { name: "Wood Grain", ral: "Natural Oak", desc: "Photo-realistic timber print." },
        "04": { name: "Pure White", ral: "RAL 9016", desc: "Clean white PVDF. Universal palette." },
        "05": { name: "Anthracite", ral: "RAL 7016", desc: "Deep architectural grey." },
        "06": { name: "Champagne Gold", ral: "Metallic Gold", desc: "Subtle metallic warmth." },
        "07": { name: "Mirror Polish", ral: "High-gloss Silver", desc: "Mirror-finish coil. Specular reflection." },
      },
    },
    specs: {
      label: "05 — Specifications",
      title: "General information",
      intro: "",
      headers: ["Available size", "Standard", "Options"],
      rows: [
        ["Width", "1,250 mm", "1,000 — 1,220 mm · 1,500 — 2,000 mm"],
        ["Length", "3,200 mm", "2,000 — 6,000 mm"],
        ["Total thickness", "2 / 3 / 4 / 5 / 6 mm", "On request"],
        ["Aluminium thickness", "0.21 / 0.30 / 0.40 / 0.50 mm", "—"],
        ["Surface & colour", "PVDF coating", "Brushed · Mirror · Wooden · Metallic · Gloss · PE · HDPE"],
        ["Packing", "Wooden pallet", "—"],
      ],
    },
    layers: {
      label: "06 — Structure",
      title: "Layers of the ACP",
      intro: "A multi-layer composite structure engineered for rigidity, weight and longevity.",
      items: [
        { n: "01", name: "Protective layer", desc: "Removable layer protecting the surface during transport and installation." },
        { n: "02", name: "Polyester / PVDF coating", desc: "Coil-coated paint resistant to UV, corrosion and weather." },
        { n: "03", name: "Aluminium plate", desc: "Coil-coated aluminium skin (0.21–0.50 mm) for rigidity and shape." },
        { n: "04", name: "Adhesive", desc: "High-temperature laminate bonding the layers together." },
        { n: "05", name: "Polyethylene / FR core", desc: "PE or fire-retardant mineral core (B1 / A2) for stability." },
      ],
    },
    sustainability: {
      label: "07 — Sustainability",
      title: "Built for the next generation.",
      intro: "MG Bond is manufactured to the highest environmental standards.",
      items: [
        { k: "100%", v: "Recyclable aluminium", l: "Fully recoverable into new production cycles." },
        { k: "0", v: "Heavy metals", l: "No lead, cadmium or chromium in the coating." },
        { k: "EU", v: "Eco production", l: "Manufacturing aligned with European environmental standards." },
      ],
    },
    contact: {
      label: "07 — Request a quotation",
      headlineL1: "Request",
      headlineL2: "a quotation.",
      intro: "",
      callLabel: "Call",
      emailLabel: "Email",
      whatsappLabel: "WhatsApp",
      officeLabel: "Office",
      officeValue: "Skopje, Macedonia",
      form: {
        nameLabel: "Name / Company",
        namePh: "Full name or company",
        emailLabel: "Email",
        emailPh: "you@company.com",
        phoneLabel: "Phone (optional)",
        phonePh: "+389 …",
        messageLabel: "Project brief",
        messagePh: "Volume (m²), finish, deadline, location…",
        eta: "",
        submit: "Send inquiry",
        sending: "Sending",
        successToast: "Inquiry received. We'll respond within one business day.",
        genericError: "Could not send your message. Please try again.",
        errors: { name: "Please enter your name.", email: "Please enter a valid email.", message: "Message must be at least 5 characters.", submit: "Submission failed." },
      },
    },
    footer: {
      description: "Official MG Bond distributor of aluminium composite panels.",
      contact: "Contact", office: "Office", city: "Skopje", country: "Macedonia",
      copyright: "© {year} S&K Facade Panels", rights: "All rights reserved",
    },
    lang: { switchTo: "МК", current: "EN" },
    docTitle: "S&K Facade Panels — Official MG Bond Distributor",
  },

  sq: {
    brand: { name: "S&K FACADE PANELS", short: "S&K", tagline: "Panele Fasade" },
    distributor: "Distributori zyrtar i MG Bond",
    nav: {
      product: "Produkti",
      finishes: "Katalogu",
      specs: "Specifikimet",
      sustainability: "Qëndrueshmëria",
      contact: "Kontakti",
      requestQuote: "Kërko ofertë",
      viewCatalogue: "Shih katalogun",
    },
    hero: {
      eyebrow: "PANELE KOMPOZITE ALUMINI",
      subEyebrow: "Distributori zyrtar i MG Bond",
      headlineBold: "Premium",
      headlineRest: "zgjidhje fasadash",
      description:
        "Panele kompozite alumini premium nga MG BOND për projekte ndërtimi — të lehta, të forta, rezistente ndaj motit. Një gamë e gjerë ngjyrash dhe dimensionesh, të dorëzuara në kohë.",
      cta: "Shih katalogun",
      marquee: ["MG Bond ACP", "PE · HDPE · PVDF", "1250 mm / 3200 mm", "2–6 mm trashësi", "100% i ricikluar", "Bërthama rezistente ndaj zjarrit"],
    },
    product: {
      label: "02 — Rreth produktit",
      sideTitle: ["MG Bond", "Premium", "ACP"],
      headlineL1: "Panele kompozite",
      headlineL2: "alumini premium",
      headlineL3: "nga MG Bond.",
      body1:
        "Panele kompozite alumini premium nga MG Bond — një markë e njohur ndërkombëtarisht për cilësi të lartë, dizajn modern dhe prodhim të qëndrueshëm.",
      body2:
        "Të krijuara për arkitekturë dhe ndërtim bashkëkohor, panelet MG Bond kombinojnë qëndrueshmëri, estetikë dhe performancë të lartë në çdo detaj. Të prodhuara me 100% alumin të ricikluar dhe teknologji të avancuar, ato përfaqësojnë një zgjidhje të zgjuar dhe të qëndrueshme për ndërtimin modern.",
      body3:
        "Pavarësisht nëse bëhet fjalë për fasada, zgjidhje të brendshme apo koncepte arkitektonike krijuese, ne ofrojmë produkte të besueshme që përmbushin standardet më të larta të cilësisë dhe stilit.",
      body4:
        "Panelet kompozite të aluminit MG Bond përdorin material 100% polietileni. Polietileni siguron rezistencë ndaj abrazionit dhe aftësinë për t'u përkulur lehtësisht pa u thyer. I kombinuar me aliazhin 3004, përmirëson vetitë mekanike dhe siguron karakteristika superiore të performancës. Ngjyra të ndryshme bërthame janë në dispozicion për materialin e polietilenit.",
      stats: [
        { k: "5.5", v: "kg / m²", l: "Pesha mesatare, panel 4 mm" },
        { k: "B1 / A2", v: "EN 13501-1", l: "Rezistenca ndaj zjarrit (klasa B1, A2)" },
        { k: "20", v: "Vite", l: "Garanci fasade, shtresa PVDF" },
        { k: "RAL", v: "Gamë e gjerë", l: "Një gamë e gjerë ngjyrash" },
      ],
      sustainability: [
        { k: "100%", v: "Alumin i ricikluar", l: "Plotësisht i rikuperueshëm në cikle të reja prodhimi." },
        { k: "0", v: "Metale të rënda", l: "Pa plumb, kadmium apo krom në shtresë." },
        { k: "EU", v: "Prodhim ekologjik", l: "Prodhim në përputhje me standardet evropiane mjedisore." },
      ],
    },
    advantages: {
      label: "03 — Pse ACP",
      title: "Pse panele kompozite alumini.",
      intro:
        "Gjashtë përparësi të matshme që e bëjnë MG Bond ACP materialin e përsosur për fasada bashkëkohore.",
      items: [
        { k: "01", t: "Konstruksion i lehtë", d: "Rreth 5.5 kg/m² për panel 4 mm — pa humbje në ngurtësi dhe rezistencë të materialit, montim më i shpejtë dhe kosto më të ulëta." },
        { k: "02", t: "Qëndrueshmëri në çdo mot", d: "Shtresa PVDF është rezistente ndaj UV, lagështisë dhe ndryshimeve termike për mbi 20 vjet me mirëmbajtje minimale." },
        { k: "03", t: "Performancë termike", d: "Bërthama kompozite zvogëlon transferimin e nxehtësisë përmes fasadës, duke mbështetur ndërtesa me efikasitet energjetik." },
        { k: "04", t: "Izolim akustik", d: "Struktura sandwich zvogëlon zhurmat e jashtme — një përfitim i matshëm për projekte urbane." },
        { k: "05", t: "Rezistencë ndaj zjarrit", d: "Bërthamat A2 / B1 plotësojnë EN 13501-1 dhe standardet rigoroze për ndërtesa komerciale." },
        { k: "06", t: "Fleksibilitet estetik", d: "Brushed, Mirror, Wooden, Metallic dhe çdo RAL — liri ngjyre dhe teksture për çdo gjuhë arkitektonike." },
      ],
    },
    finishes: {
      label: "04 — Katalogu i ngjyrave",
      headlineL1: "Paleta MG Bond.",
      headlineL2: "",
      intro:
        "Paleta e plotë MG Bond — njëngjyrëshe, metalik, pasqyrë, të krehur dhe dekor druri. Ngjyra të personalizuara në dispozicion për projekte tenderi.",
    },
    specs: {
      label: "05 — Specifikimet",
      title: "Informacion i përgjithshëm",
      intro: "",
      headers: ["Dimensioni i disponueshëm", "Standard", "Opsione"],
      rows: [
        ["Gjerësia", "1,250 mm", "1,000 — 1,220 mm · 1,500 — 2,000 mm"],
        ["Gjatësia", "3,200 mm", "2,000 — 6,000 mm"],
        ["Trashësia totale", "2 / 3 / 4 / 5 / 6 mm", "Me kërkesë"],
        ["Trashësia e aluminit", "0.21 / 0.30 / 0.40 / 0.50 mm", "—"],
        ["Sipërfaqja dhe ngjyra", "Shtresa PVDF", "Brushed · Mirror · Wooden · Metallic · Gloss · PE · HDPE"],
        ["Paketimi", "Paletë druri", "—"],
      ],
    },
    layers: {
      label: "06 — Struktura",
      title: "Shtresat e ACP",
      intro: "Strukturë kompozite shumështresore për ngurtësi, peshë dhe jetëgjatësi optimale.",
      items: [
        { n: "01", name: "Shtresë mbrojtëse", desc: "Shtresë e heqshme që mbron sipërfaqen gjatë transportit dhe montimit." },
        { n: "02", name: "Shtresë poliestër / PVDF", desc: "Bojë e veshur rezistente ndaj UV, korrozionit dhe kushteve atmosferike." },
        { n: "03", name: "Pllakë alumini", desc: "Shtresë alumini e veshur 0.21–0.50 mm për ngurtësi dhe formë." },
        { n: "04", name: "Ngjitës", desc: "Ngjitës laminat me temperaturë të lartë që lidh shtresat." },
        { n: "05", name: "Bërthamë polietileni / FR", desc: "Bërthamë PE ose mineral rezistent ndaj zjarrit (B1 / A2) për stabilitet." },
      ],
    },
    contact: {
      label: "07 — Kërkesë për ofertë",
      headlineL1: "Kërkesë",
      headlineL2: "për ofertë.",
      intro: "",
      callLabel: "Telefono",
      emailLabel: "Email",
      whatsappLabel: "WhatsApp",
      officeLabel: "Zyra",
      officeValue: "Shkup, Maqedoni",
      form: {
        nameLabel: "Emri / Kompania",
        namePh: "Emri i plotë ose emri i kompanisë",
        emailLabel: "Email",
        emailPh: "ju@kompania.com",
        phoneLabel: "Telefon (opsional)",
        phonePh: "+389 …",
        messageLabel: "Përshkrimi i projektit",
        messagePh: "Sasia (m²), finish, afati, vendndodhja…",
        eta: "",
        submit: "Dërgo kërkesën",
        sending: "Po dërgohet",
        successToast: "Kërkesa u pranua. Do të përgjigjemi brenda një dite pune.",
        genericError: "Nuk mund të dërgojmë mesazhin tuaj. Provoni përsëri.",
        errors: { name: "Ju lutem shkruani emrin tuaj.", email: "Ju lutem shkruani një email të vlefshëm.", message: "Mesazhi duhet të jetë së paku 5 karaktere.", submit: "Dërgimi dështoi." },
      },
    },
    footer: {
      description: "Distributori zyrtar i MG Bond i paneleve kompozite të aluminit.",
      contact: "Kontakti", office: "Zyra", city: "Shkup", country: "Maqedonia",
      copyright: "© {year} S&K Facade Panels", rights: "Të gjitha të drejtat e rezervuara",
    },
    lang: { switchTo: "SQ", current: "SQ" },
    docTitle: "S&K Facade Panels — Distributori zyrtar i MG Bond",
  },
};

export const DEFAULT_LANG = "mk";
export const SUPPORTED_LANGS = ["mk", "en", "sq"];
